export const POLLS_TYPE = {
  MULTIPLE_CHOICE: "multipleChoice",
  RATING: "rating",
  QUESTION: "question",
  WORD_CLOUD: "wordCloud",
  QUIZ: "quiz",
  RANKING: "ranking",
};

export const MICROSITE_TYPE = {
  AGENDA: "agenda",
  DOCUMENTS: "documents",
  INTRODUCTION: "introduction",
  SPEAKERS: "speakers",
  SPONSORS: "sponsors",
  VIDEOS: "videos",
  CODESNIPPET: "code snippet",
};
